import { useQuery } from '@apollo/client';
import GavelIcon from '@mui/icons-material/Gavel';
import PersonIcon from '@mui/icons-material/Person';
import { Button, styled } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ClientsModal from './ClientsModal';

import {
  CLIENTS_QUERY,
  CLIENTS_SUBSCRIPTION,
  clientsSubscriptionHandler,
} from '../../schema/portal';

const StyledButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0, 1),
  border: `1px solid ${theme.palette.background.lightblue}`,
  borderRadius: '1rem',
  color: theme.palette.background.lighterblue,
  display: 'flex',
  gap: theme.spacing(1),
  span: {
    fontSize: '150%',
    span: {
      fontSize: '100%',
      color: 'white',
    },
    '.MuiSvgIcon-root': {
      fontSize: '1.5rem',
      verticalAlign: 'text-bottom',
    }
  }
}));



const compareClients = (a, b) => {
  const a_num = (a && a.number) || 0;
  const b_num = (b && b.number) || 0;
  const a_name = (a && a.name) || '';
  const b_name = (b && b.name) || '';
  return (a_num == b_num) ? a_name.localeCompare(b_name) : a_num - b_num;
}

const ClientBadges = () => {
  const { data, error, loading, subscribeToMore } = useQuery(CLIENTS_QUERY);
  const { t } = useTranslation();

  const [showDialog, setShowDialog] = React.useState(false);

  React.useEffect(() => {
    subscribeToMore({
      document: CLIENTS_SUBSCRIPTION,
      updateQuery: clientsSubscriptionHandler,
    });
  }, [subscribeToMore]);

  const clients = React.useMemo(() => {
    if (loading || error || !data || !data.onlineClients) {
      return [];
    }
    const cs = [...data.onlineClients];
    cs.sort(compareClients);
    return cs;
  }, [data, error, loading]);

  const auctioneerCount = React.useMemo(() => clients.filter(c => !c.number).length, [clients])
  const bidderCount = React.useMemo(() => clients.filter(c => !!c.number).length, [clients])

  return <>
    <StyledButton onClick={() => setShowDialog(true)}>
      <span title={t('portal.clientCountAuctioneers', { count: auctioneerCount })}>
        <GavelIcon />
        <span>{auctioneerCount}</span>
      </span>
      <span title={t('portal.clientCountBidders', { count: bidderCount })}>
        <PersonIcon />
        <span>{bidderCount}</span>
      </span>
    </StyledButton>
    <ClientsModal clients={clients} handleClose={() => setShowDialog(false)} open={showDialog} />
  </>;
};

export default ClientBadges;
